import axios from 'axios';
import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import UserContext from '../../contexts/UserContext';
import authenticate from '../../utils/Authenticate';

const SupplierDispatch = () => {
  const location = useLocation();
  const { request, approvedItems } = location.state || {};
  const { user, setUser } = useContext(UserContext);
  const navigate = useNavigate();
  const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [currentRequest,setCurrentRequest] = useState(null);
    const [currentSupplier,setCurrentSupplier] = useState(null);
    const [showBillUpload,setShowBillUpload] = useState(false)
    const [currentBill,setCurrentBill] = useState(null)

  console.log(approvedItems);

  // Initial form state with default values
  const [formData, setFormData] = useState({
    comments: '',
    vehicleNo: '',
    address: approvedItems[0].zone.address || '',
    contact: ''
  });

  // Initial state for quantities
  const [quantities, setQuantities] = useState(
    approvedItems.reduce((acc, item) => {
      acc[item._id] = item.quantity;
      return acc;
    }, {})
  );

  // Update form data state on change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  // Update quantity state on change
  const handleQuantityChange = (e, itemId) => {
    setQuantities({
      ...quantities,
      [itemId]: e.target.value
    });
  };

  // Authenticate user on component mount
  useEffect(() => {
    const startup = async () => {
      if (!user) {
        await authenticate(setUser, navigate);
      }
    };
    startup();
  }, [user, navigate, setUser]);

  // Handle form submission
  const submitSupplierForRequest = (e) => {
    e.preventDefault();

    // Prepare the final request object with dispatch details
    const finalObject = {
      request: {
        ...request,
        items: approvedItems.map(item => {
          // Determine if we should update supplier or zoneSupplier dispatch details
          const dispatchDetails = {
            comments: formData.comments,
            vehicleNo: formData.vehicleNo,
            contact: formData.contact,
            address: formData.address,
            dispatchedAt: new Date().toISOString() // Adding dispatch timestamp
          };

          const updatedItem = {
            ...item,
            quantity: quantities[item._id], // Update the quantity with the new value
            status: 'Dispatched'
          };

          if (item.supplier) {
            return {
              ...updatedItem,
              supplier: {
                ...item.supplier,
                dispatch: dispatchDetails
              }
            };
          } else if (item.zoneSupplier) {
            return {
              ...updatedItem,
              zoneSupplier: {
                ...item.zoneSupplier,
                dispatch: dispatchDetails
              }
            };
          } else {
            // If neither is available, just return the item (shouldn't happen in your use case)
            return updatedItem;
          }
        })
      }
    };

    // Post the dispatch details to the server
    axios.post(`${process.env.REACT_APP_API_URI}/api/supplier/updateDispatch`, finalObject, { withCredentials: true })
      .then((response) => {
        console.log(response.data);
        // Navigate back to the supplier home after successful submission
        setTimeout(() => {
          navigate('/supplier/home');
        }, 1000);
      })
      .catch((error) => {
        console.error(error);
      });
  };


  const checkForBills = (request) => {
    axios.get(`${process.env.REACT_APP_API_URI}/api/bill/get?requestId=${request}&supplierName=${user.name}`,{withCredentials:true})
    .then((response) => {
        console.log(response);
        if(response.data.success){
            setCurrentBill(response.data.data)
        }
    })
    .catch((err) =>{
        setErrorMessage('An error occurred while processing your request. Please try again.');
        setSuccessMessage('');
        console.error(err);
    })
}

const submitData = (e) => {
    e.preventDefault();
    console.log(e.target.bill.files[0]);
    const finalObject = {
        bill:e.target.bill.files[0],
        request:currentRequest._id,
        supplier:user.name
    }
    axios.put(`${process.env.REACT_APP_API_URI}/api/bill/update`, finalObject, { headers: {
        'Content-Type': 'multipart/form-data'
    },
    withCredentials: true })
        .then((response) => {
            console.log(response.data);
        })
        .catch((error) => {
            console.error(error);
        });
    checkForBills(currentRequest._id);
};


const showUpload = async (request) => {
 checkForBills(request._id);
    setCurrentRequest(request);
    setShowBillUpload(true);
    document.body.style.overflow = 'hidden'; // Disable scrolling
  };

  const closeModals = () => {
    setShowBillUpload(false);
    document.body.style.overflow = 'auto'; // Enable scrolling
    setCurrentBill(null)
  };

const BillUploadCard = () => (
    <>
      <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50 z-50">
        <div className="bg-white rounded-lg shadow dark:bg-gray-700 max-w-2xl w-full mx-3">
          <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
            <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
              Bill Upload
            </h3>
            <button onClick={closeModals} className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white">
              <svg className="w-3 h-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
              </svg>
              <span className="sr-only">Close modal</span>
            </button>
          </div>
          <div className="p-4 md:p-5 space-y-4">
            <div>
                {currentBill?
                 <>
                 <h4>Bill Uploaded</h4>
                 <img src={currentBill.file}></img>
                 </>
                 :
                 null
                }
            </div>
            <form onSubmit={submitData}>
            <input
            type="file"
            name='bill'
            className="flex w-full justify-center rounded-full text-white bg-fmb-light px-3 py-3 text-sm font-semibold leading-6 shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            accept=".jpg,jpeg,.png,.doc,.docx,.pdf"
            />
            <button
              type="submit"
              className={`flex w-full mt-4 justify-center rounded-full
               text-white bg-fmb px-3 py-3 text-sm font-semibold 
               leading-6 shadow-sm hover:bg-indigo-500 focus-visible:outline 
               focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600`}
            >
              UPLOAD BILL
            </button>
            </form>
          </div>
          <div className="flex items-center p-4 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600">
            <button onClick={closeModals} className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">OK</button>
            <button onClick={closeModals} className="py-2.5 px-5 ml-3 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">Close</button>
          </div>
        </div>
      </div>
    </>
  );


  return (
    <>
      <div className="bg-lime-800 text-lime-100 p-4 w-full shadow-md flex items-center mb-4">
        <div className="mr-4 cursor-pointer" onClick={() => navigate(-1)}>
          <span className="text-xl">←</span>
        </div>
        <h4 className="text-lg md:text-xl font-semibold text-center flex-grow">Dispatch</h4>
      </div>
      <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-4 lg:px-8">
        <form className="space-y-6" onSubmit={submitSupplierForRequest}>
          <div>
            <label htmlFor="comments" className="block text-sm font-medium leading-6 text-gray-900">
              Comments
            </label>
            <div className="mt-2">
              <input
                id="comments"
                name="comments"
                type="text"
                placeholder='Comments'
                value={formData.comments}
                onChange={handleChange}
                required
                className="block w-full rounded-full border-0 py-3 px-5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>

          <div>
            <label htmlFor="vehicleNo" className="block text-sm font-medium leading-6 text-gray-900">
              Vehicle Number
            </label>
            <div className="mt-2">
              <input
                id="vehicleNo"
                name="vehicleNo"
                type="text"
                placeholder='Vehicle Number'
                value={formData.vehicleNo}
                onChange={handleChange}
                required
                className="block w-full rounded-full border-0 py-3 px-5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>

          <div>
            <label htmlFor="contact" className="block text-sm font-medium leading-6 text-gray-900">
              Contact
            </label>
            <div className="mt-2">
              <input
                id="contact"
                name="contact"
                type="text"
                placeholder='Contact'
                value={formData.contact}
                onChange={handleChange}
                required
                className="block w-full rounded-full border-0 py-3 px-5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>

          <div>
            <label htmlFor="address" className="block text-sm font-medium leading-6 text-gray-900">
              Address
            </label>
            <div className="mt-2">
              <input
                id="address"
                name="address"
                type="text"
                placeholder='Address'
                value={formData.address}
                onChange={handleChange}
                required
                className="block w-full rounded-full border-0 py-3 px-5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>

          {approvedItems.map(item => (
            <div key={item._id}>
              <label htmlFor={`quantity-${item._id}`} className="block text-sm font-medium leading-6 text-gray-900">
                {item.item.name} Quantity
              </label>
              <div className="mt-2">
                <input
                  id={`quantity-${item._id}`}
                  name={`quantity-${item._id}`}
                  type="number"
                  value={quantities[item._id]}
                  onChange={(e) => handleQuantityChange(e, item._id)}
                  required
                  className="block w-full rounded-full border-0 py-3 px-5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
          ))}
                      <div>
                <div className='flex justify-between mb-2'>

                    <div>
                    <button onClick={() => showUpload(request)}
                        className="bg-fmb text-white py-2 px-3 rounded text-xs font-normal hover:bg-yellow-500 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-opacity-50">
                            Upload Bill
                    </button>
                    </div>
                </div>
            </div>
          <div>
            <button
              type="submit"
              className="flex w-full justify-center rounded-full text-white bg-fmb px-3 py-3 text-sm font-semibold leading-6 shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              SUBMIT
            </button>
          </div>
        </form>
        {showBillUpload && <BillUploadCard />}
      </div>
    </>

  );
};

export default SupplierDispatch;
